import { mdiChevronRight } from '@mdi/js';
import { Icon } from '@mdi/react';
import React, { useState } from 'react';
import * as S from './collapsible-container.styles';

export interface ICollapsibleContainerProps {
    title?: string;
    titleComponent?: React.ReactNode | ((isOpen: boolean) => React.ReactNode);
    defaultOpen?: boolean;
    children: React.ReactNode;
    className?: string;
}

export const CollapsibleContainer: React.FunctionComponent<ICollapsibleContainerProps> = (
    props: ICollapsibleContainerProps
): React.ReactElement => {
    const { title, titleComponent, defaultOpen = false, children, className } = props;
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const renderTitle = () => {
        if (title) {
            return <S.Title>{title}</S.Title>;
        }
        if (typeof titleComponent === 'function') {
            return titleComponent(isOpen);
        }
        return titleComponent;
    };

    return (
        <S.Container className={className}>
            <S.Header onClick={handleToggle}>
                {renderTitle()}
                <S.ChevronIcon isOpen={isOpen}>
                    <Icon path={mdiChevronRight} size={0.75} />
                </S.ChevronIcon>
            </S.Header>
            <S.Content isOpen={isOpen}>
                {children}
            </S.Content>
        </S.Container>
    );
};

